import {
    useQueryClient,
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRelation } from '../../interfaces'
import { deleteRelation } from '../../../../services/dtServices'

export const useDeleteRelation = (
    entityTemplateId: string,
    orgId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRelation>>,
    Error,
    string
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (relKey: string) => {
            return deleteRelation(entityTemplateId, relKey, orgId)
        },
        //client side optimistic update
        onMutate: (relationId: string) => {
            queryClient.setQueryData(
                ['relations', entityTemplateId, orgId],
                (relations: IRelation[]) =>
                    relations?.filter(
                        (relation: IRelation) => relation.id !== relationId,
                    ),
            )
        },
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['relations', entityTemplateId],
            }), //refetch relations after mutation
    })
}
